import { render, staticRenderFns } from "./PluginOrders.vue?vue&type=template&id=56f5775a&scoped=true&"
import script from "./PluginOrders.vue?vue&type=script&lang=js&"
export * from "./PluginOrders.vue?vue&type=script&lang=js&"
import style0 from "./PluginOrders.vue?vue&type=style&index=0&id=56f5775a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f5775a",
  null
  
)

export default component.exports